/**
 * @generated SignedSource<<44907f054192acfb86b926b14bdad639>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type IncomingInvoiceViewQuery$variables = {
  id: string;
};
export type IncomingInvoiceViewQuery$data = {
  readonly expenseInvoice: {
    readonly currency: string;
    readonly deletedInFastBillAt: any | null | undefined;
    readonly dueDate: any | null | undefined;
    readonly exchangeRate: number;
    readonly expenseCategory: ExpenseCategory | null | undefined;
    readonly expenseCategoryOverride: ExpenseCategory | null | undefined;
    readonly fastBillInvoiceId: string;
    readonly grossAmount: number;
    readonly hasDocument: boolean;
    readonly id: string;
    readonly invoiceDate: any;
    readonly invoiceNumber: string | null | undefined;
    readonly netAmount: number;
    readonly netAmountInEuro: number;
    readonly paidDate: any | null | undefined;
    readonly supplierIdentifier: string;
    readonly supplierName: string;
    readonly supplierSpelling: string;
    readonly vatAmount: number;
    readonly " $fragmentSpreads": FragmentRefs<"ExpenseInvoiceServicePeriod_invoice">;
  };
};
export type IncomingInvoiceViewQuery = {
  response: IncomingInvoiceViewQuery$data;
  variables: IncomingInvoiceViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fastBillInvoiceId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supplierIdentifier",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supplierName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supplierSpelling",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceDate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paidDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "netAmount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vatAmount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grossAmount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeRate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "netAmountInEuro",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseCategory",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseCategoryOverride",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDocument",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedInFastBillAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IncomingInvoiceViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExpenseInvoice",
        "kind": "LinkedField",
        "name": "expenseInvoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ExpenseInvoiceServicePeriod_invoice"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IncomingInvoiceViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExpenseInvoice",
        "kind": "LinkedField",
        "name": "expenseInvoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodSource",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "servicePeriodStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f79f72d8f970820265b37f95d2cd2f50",
    "id": null,
    "metadata": {},
    "name": "IncomingInvoiceViewQuery",
    "operationKind": "query",
    "text": "query IncomingInvoiceViewQuery(\n  $id: ID!\n) {\n  expenseInvoice(id: $id) {\n    id\n    fastBillInvoiceId\n    supplierIdentifier\n    supplierName\n    supplierSpelling\n    invoiceNumber\n    invoiceDate\n    dueDate\n    paidDate\n    currency\n    netAmount\n    vatAmount\n    grossAmount\n    exchangeRate\n    netAmountInEuro\n    expenseCategory\n    expenseCategoryOverride\n    hasDocument\n    deletedInFastBillAt\n    ...ExpenseInvoiceServicePeriod_invoice\n  }\n}\n\nfragment ExpenseInvoiceServicePeriod_invoice on ExpenseInvoice {\n  id\n  invoiceDate\n  servicePeriodStart\n  servicePeriodEnd\n  servicePeriodSource\n  servicePeriodStatus\n}\n"
  }
};
})();

(node as any).hash = "6e037a992ecc13e2dfe5ec43ed3e4a76";

export default node;
